// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"f7b16992","241":"73711540","498":"0ddf449e","787":"1531a67a","893":"a8149ece"}[chunkId] + ".chunk.js";
};